import isValidAmazonLink from './isValidAmazonLink';

const hasOnlyAmazonLinks = (value: string) => {
  // Reference: https://urlregex.com/
  const urls = value!.match(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w\-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[.!/\\\w]*))?)/igm) || [];
  // Return false if any URLs aren't Amazon
  return !urls.find((url) => !isValidAmazonLink(url.startsWith('http') ? url : `https://${url}`));
};

export default hasOnlyAmazonLinks;
